// Version : 0.0.1
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import progressReportTypes from './progress-report.types';
import { getProgressReport } from './progress-report.services';
import {
	getProgressReportSuccess,
	getProgressReportFailure,
	getProgressReportChanged,
} from './progress-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET PROGRESS DETAILS  ******************** */
export function* getProgressReportList({ payload }: any) {
	try {
		const { companyID, officerID, branchID, databaseName, fromDate, endDate, isThrift } =
			payload;
		const key = 'GetBranchProgressListKey';
		const jsonData = {
			CompanyID: companyID,
			OfficerID: officerID,
			BranchID: branchID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: endDate,
			IsThriftActive: isThrift,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getProgressReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProgressReportFailure(responseData.data));
		} else {
			yield put(getProgressReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProgressReportFailure(error));
	}
}

export function* resetProgressReportResponse() {
	yield put(getProgressReportChanged());
}

export function* onResetProgressReportList() {
	yield takeLatest(progressReportTypes.GET_PROGRESS_REPORT_START, getProgressReportList);
}

export function* onResetProgressReportResponseReset() {
	yield takeLatest(progressReportTypes.GET_PROGRESS_REPORT_RESET, resetProgressReportResponse);
}
/** *********************  END GET PROGRESS LIST ******************** */

export function* progressReportSaga() {
	yield all([call(onResetProgressReportList), call(onResetProgressReportResponseReset)]);
}
